import { useCallback } from 'react';

import { FeatureFlag } from 'src/shared/constants';
import { useTreatment } from 'src/shared/hooks';

import { createAiOriginalImage } from '../services';

import { useHomeownerAppContext } from '.';

export const useUploadOriginalImage = () => {
  const { trackingData } = useHomeownerAppContext();

  const uploadDirectlyToHyperion =
    useTreatment(FeatureFlag.Web.HOMEOWNER_APP_UPLOAD_TO_HYPERION) === 'on';

  return useCallback(
    async (variables: { image: File; email?: string; spaceType?: string }) => {
      const result = await createAiOriginalImage(
        variables.image,
        {
          email: variables.email,
          spaceType: variables.spaceType,
        },
        trackingData,
        uploadDirectlyToHyperion,
      );

      return result;
    },
    [trackingData, uploadDirectlyToHyperion],
  );
};
